import React, {useState} from 'react';
import styled from 'styled-components';
// import Header from '../components/Header'; // Removed Header import
import Footer from '../components/Footer';
import ProgramList from '../components/ProgramList';
import RegistrationForm from '../components/RegistrationForm';
// import Terms from '../components/Terms';
import Modal from "../components/Modal";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex-grow: 1;
  padding: 20px 0; /* Add some vertical padding */
`;

// Base styles for intro sections
const BaseIntroStyles = `
  font-family: 'Oswald', 'Arial Black', sans-serif;
  color: #133B5C;
  text-transform: uppercase;
  line-height: 1.6;
  font-size: 1.1em;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px 40px;
  margin-bottom: 40px;

  strong {
    font-weight: bold;
    color: #2A7131;
  }
`;

// Styles for Individual Mini-Cards (formerly Suggestion 2)
const IntroListMiniCards = styled.div`
  ${BaseIntroStyles}

  p {
    text-align: left;
    padding: 15px 20px; /* Padding inside each mini-card */
    margin-bottom: 15px; /* Spacing between mini-cards */
    border: 1px solid #e0e0e0; /* Soft border for mini-card */
    border-radius: 4px; /* Optional: rounded corners for mini-cards */
    background-color: #fdfdfd; /* Very subtle background for cards */
  }

  p:last-child {
    margin-bottom: 0;
  }

  /* Responsive: adjust padding for smaller screens */
  @media (max-width: 768px) {
    padding: 20px 20px;
  }
`;

const HomePage: React.FC = () => {
    const [acceptedTerms, setAcceptedTerms] = useState(true)

    const [showModal, setShowModal] = useState(false)


    const introParagraphs = [
      "Vending Rebates focuses on getting members rebates on specific programs, we partner with Entegra / Sodexo to make these programs available to you.",
      "Vending Rebates gets you rebates on purchases you already make from the qualified distributors for the <strong>Included Manufacturers</strong> listed. Our goal is to get you additional rebates on purchases from these <strong>Included Manufacturers</strong> that you may not already be getting rebates on.",
      "We focus on these <strong>Included Manufacturers</strong> because they seem to be the most popular that vendors do not get rebates on.",
      "There is no cost to join and by adding you to the membership it increases the volume for the GPO which allows us to earn a portion of rebates, as well."
    ];

    return (
    <PageWrapper>
      {/* <Header /> */}{/* Removed Header instance */}
      <MainContent>
          <IntroListMiniCards>
            {/* Title for this section can be added here if desired, or removed if intro is self-explanatory */}
            {/* e.g., <h2 style={{textAlign: 'center', color: '#133B5C', marginBottom: '20px'}}>Welcome to Vending Rebates</h2> */}
            {introParagraphs.map((text, index) => (
              <p key={`minicard-${index}`} dangerouslySetInnerHTML={{ __html: text }} />
            ))}
          </IntroListMiniCards>

          {/*{ !showModal && !acceptedTerms && <Terms acceptTerms={acceptedTerms} updateTerms={setAcceptedTerms}  /> }*/}
          { !showModal && acceptedTerms && <ProgramList /> }
          { !showModal && acceptedTerms && <RegistrationForm /> }
          { showModal && <Modal show={showModal} updateShow={setShowModal} /> }
      </MainContent>
      <Footer show={showModal} updateShow={setShowModal} />

    </PageWrapper>
  );
};

export default HomePage; 